import { t } from "i18next";
import { useMe } from "@/data/user";
import { Outlet } from "react-router-dom";
// import { useMore } from "@/contexts/MoreContext";
import { SidebarItem } from "@/types";
import Home from "@/pages/Home";
import Login from "@/pages/Login";
import ROUTES from "@/config/routes.ts";
import Agenda from "@/pages/Agenda.tsx";
import LoginV3 from "@/pages/v3/LoginV3";
import Confirm from "@/pages/one-to-one/Confirm.tsx";
import NotFound from "@/pages/NotFound";
import Invoices from "@/pages/Invoices.tsx";
import OneToOne from "@/pages/OneToOne.tsx";
import BookExam from "@/pages/book-exam/Index.tsx";
import Recharge from "@/pages/one-to-one/Recharge";
import HomeIcon from "@/components/icons/HomeIcon.tsx";
import Dashboard from "@/pages/Dashboard.tsx";
import Exercises from "@/pages/Exercises.tsx";
import ReferIcon from "@/components/icons/ReferIcon.tsx";
import SelectHour from "@/pages/one-to-one/SelectHour";
import AgendaIcon from "@/components/icons/AgendaIcon.tsx";
import ChangeEvent from "@/pages/ChangeEvent.tsx";
import ClassReport from "@/pages/ClassReport.tsx";
import NewPassword from "@/pages/NewPassword.tsx";
import ExamDetails from "@/pages/book-exam/Details.tsx";
import InvoiceIcon from "@/components/icons/InvoiceIcon.tsx";
import SelectTutor from "@/pages/one-to-one/SelectTutor.tsx";
import ExerciseIcon from "@/components/icons/ExerciseIcon.tsx";
import FeedbackIcon from "@/components/icons/FeedbackIcon.tsx";
import OneToOneIcon from "@/components/icons/OneToOneIcon.tsx";
import Availability from "@/pages/Availability.tsx";
import ReferAFriend from "@/pages/ReferAFriend.tsx";
import Registration from "@/pages/Registration.tsx";
import EventDetails from "@/pages/agenda/EventDetails.tsx";
import BookMockTest from "@/pages/exercises/BookMockTest.tsx";
import MaterialFile from "@/pages/materials/MaterialFile.tsx";
import ResetPassword from "@/pages/ResetPassword.tsx";
// import DeleteAccount from "@/pages/DeleteAccount.tsx";
import NewPasswordV3 from "@/pages/v3/NewPasswordV3";
import MaterialsList from "@/pages/materials/MaterialsList.tsx";
import BookExamsIcon from "@/components/icons/BookExamsIcon.tsx";
import MaterialsIcon from "@/components/icons/MaterialsIcon.tsx";
import DiplomaRequest from "@/pages/DiplomaRequest.tsx";
import FeedbackAgenda from "@/pages/agenda/Feedback.tsx";
import ResetPasswordV3 from "@/pages/v3/ResetPasswordV3";
import AccessEventLink from "@/pages/AccessEventLink.tsx";
import MaterialsLayout from "@/layouts/MaterialsLayout.tsx";
import ReadingExercise from "@/pages/exercises/ReadingExercise";
import GrammarExercise from "@/pages/exercises/GrammarExercise.tsx";
import WritingExercise from "@/pages/exercises/WritingExercise.tsx";
import AvailabilityIcon from "@/components/icons/AvailabilityIcon.tsx";
import AgendaChangeEvent from "@/pages/agenda/ChangeEvent";
import BookSpeakingClass from "@/pages/agenda/BookSpeakingClass";
import ListeningExercise from "@/pages/exercises/ListeningExercise.tsx";
import ClassReportLayout from "@/components/class-report/ClassReportLayout";
import DiplomaRequestIcon from "@/components/icons/DiplomaRequestIcon.tsx";
import BookLiveCorrection from "@/pages/exercises/correction/BookLiveCorrection.tsx";
import ParentRequestLayout from "@/layouts/ParentRequestLayout.tsx";
import ConfirmAvailability from "@/pages/availability/ConfirmAvailability.tsx";
import DiplomaRequestLayout from "@/layouts/DiplomaRequestLayout.tsx";
import ConfirmSecondSession from "@/pages/one-to-one/ConfirmSecondSession";
import SecondSessionDetails from "@/pages/one-to-one/SecondSessionDetails.tsx";
import PasswordChangeSuccess from "@/pages/v3/PasswordChangeSuccess";
import DiplomaRequestConfirm from "@/pages/diploma-request/Confirm.tsx";
// import GrammarExerciseResult from "@/components/exercises/grammar/Mobile/GrammarExerciseResult";
import SelectForSecondSession from "@/pages/one-to-one/SelectForSecondSession";
import ClassReportRequestLayout from "@/layouts/ClassReportRequestLayout";
import DiplomaRequestSelectDate from "@/pages/diploma-request/SelectDate.tsx";
import DiplomaRequestSelectHour from "@/pages/diploma-request/SelectHour.tsx";
import MobileBookMockTestConfirm from "@/pages/exercises/MobileBookMockTestConfirm.tsx";
import WritingExerciseCorrection from "@/pages/exercises/correction/WritingExerciseCorrection";
import GrammarExerciseCorrection from "@/pages/exercises/correction/GrammarExerciseCorrection.tsx";
import MobileLiveCorrectionError from "@/pages/exercises/correction/MobileLiveCorrectionError.tsx";
import ReadingExerciseCorrection from "@/pages/exercises/correction/ReadingExerciseCorrection.tsx";
import DiplomaRequestNotification from "@/pages/diploma-request/RequestNotification.tsx";
import ListeningExerciseCorrection from "@/pages/exercises/correction/ListeningExerciseCorrection.tsx";
import MobileConfirmLiveCorrection from "@/pages/exercises/correction/MobileConfirmLiveCorrection.tsx";
import PasswordExpiration from "@/pages/PasswordExpiration";

const useRouteObjects = () => {
  const { me } = useMe();
  // const { isBeta } = useMore();

  const absolutePathChildren = [
    { path: ROUTES.login, element: <Login /> },

    { path: ROUTES.register, element: <Registration /> },
    { path: ROUTES.reset_password, element: <ResetPassword /> },
    // { path: ROUTES.delete_account, element: <DeleteAccount /> }, // future implementation
    { path: ROUTES.new_password, element: <NewPassword /> },
    { path: ROUTES.password_expiration, element: <PasswordExpiration /> },
    { path: ROUTES.impersonate, element: <></> },
    {
      path: ROUTES.change_event,
      element: <ChangeEvent />,
    },
    {
      path: ROUTES.access_event,
      element: <AccessEventLink />,
    },
    { path: "*", element: <NotFound /> },

    // v3 absolute paths
  ];

  const absolutePathChildrenV3 = [
    { path: ROUTES.loginV3, element: <LoginV3 /> },
    { path: ROUTES.resetV3, element: <ResetPasswordV3 /> },
    { path: ROUTES.new_passwordv3, element: <NewPasswordV3 /> },
    { path: ROUTES.new_passwordv3, element: <NewPasswordV3 /> },
    { path: ROUTES.new_password_successv3, element: <PasswordChangeSuccess /> },
  ];

  const materialsChildren = [
    { path: "", element: <MaterialsList /> },
    { path: "file", element: <MaterialFile /> },
    { path: "list/:id/file", element: <MaterialFile /> },
    { path: ":id/file", element: <MaterialFile /> },
  ];

  const agendaChildren = [
    { path: "", element: <Agenda /> },
    { path: "event", element: <EventDetails /> },
    { path: "change-event", element: <AgendaChangeEvent /> },
    // { path: "booking", element: <CorrectionBookingDetails /> },
    // { path: "mock-test", element: <MockTestBookingDetails /> },
    { path: "feedback", element: <FeedbackAgenda /> },
    { path: "book-speaking-class", element: <BookSpeakingClass /> },
  ];

  const diplomaRequestChildren = [
    { path: "", element: <DiplomaRequest /> },
    {
      path: ROUTES.diploma_request_select_date,
      element: <DiplomaRequestSelectDate />,
    },
    {
      path: ROUTES.diploma_request_select_hour,
      element: <DiplomaRequestSelectHour />,
    },
    {
      path: ROUTES.diploma_request_confirm,
      element: <DiplomaRequestConfirm />,
    },
    {
      path: ROUTES.diploma_request_request_notification,
      element: <DiplomaRequestNotification />,
    },
  ];

  const availabilityChildren = [
    { path: "", element: <Availability /> },
    {
      path: ROUTES.confirm_availability,
      element: <ConfirmAvailability />,
    },
  ];

  const exerciseChildren = [
    { path: "", element: <Exercises /> },
    { path: "reading/:id", element: <ReadingExercise /> },
    { path: "listening/:id", element: <ListeningExercise /> },
    { path: "writing/:id", element: <WritingExercise /> },
    { path: "pot/:id", element: <GrammarExercise /> },
    { path: "grammar/:id", element: <GrammarExercise /> },
    // { path: "results", element: <GrammarExerciseResult /> },
    {
      path: ROUTES.exercises_mock_test,
      element: <Outlet />,
      children: [
        { path: "", element: <BookMockTest /> },
        { path: "confirm", element: <MobileBookMockTestConfirm /> },
      ],
    },
    {
      path: "correction",
      children: [
        { path: "reading/:id", element: <ReadingExerciseCorrection /> },
        {
          path: "listening/:id",
          element: <ListeningExerciseCorrection />,
        },
        { path: "grammar/:id", element: <GrammarExerciseCorrection /> },
        { path: "writing/:id", element: <WritingExerciseCorrection /> },
        {
          path: "book-live",
          element: <Outlet />,
          children: [
            { path: "", element: <BookLiveCorrection /> },
            {
              path: "confirm",
              element: <MobileConfirmLiveCorrection />,
            },
            {
              path: "booking-error",
              element: <MobileLiveCorrectionError />,
            },
          ],
        },
      ],
    },
  ];

  const classReportChildren = [
    { path: "", element: <ClassReport /> },
    { path: ":userId/:eventId", element: <ClassReportLayout /> },
  ];

  const dashboardChildren = [
    {
      path: ROUTES.dashboard,
      element: <Dashboard />,
    },
    {
      path: ROUTES.home,
      element: <Home />,
    },
    {
      path: ROUTES.agenda,
      element: <ParentRequestLayout />,
      children: agendaChildren,
    },
    {
      path: ROUTES.book_exam,
      element: <BookExam />,
    },
    {
      path: ROUTES.book_exam_details,
      element: <ExamDetails />,
    },
    {
      path: ROUTES.refer_friend,
      element: <ReferAFriend />,
    },
    {
      path: ROUTES.invoices,
      element: <Invoices />,
    },

    {
      path: ROUTES.class_report,
      element: <ClassReportRequestLayout />,
      children: classReportChildren,
    },

    {
      path: ROUTES.diploma_request,
      element: <DiplomaRequestLayout />,
      children: diplomaRequestChildren,
    },
    {
      path: ROUTES.availability,
      element: <ParentRequestLayout />,
      children: availabilityChildren,
    },
    {
      path: ROUTES.one_to_one,
      element: <OneToOne />,
    },
    {
      path: ROUTES.one_to_one_recharge,
      element: <Recharge />,
    },
    {
      path: ROUTES.one_to_one_select_hour,
      element: <SelectHour />,
    },
    {
      path: ROUTES.one_to_one_select_tutor,
      element: <SelectTutor />,
    },
    {
      path: ROUTES.one_to_one_confirm,
      element: <Confirm />,
    },
    {
      path: ROUTES.one_to_one_second_session,
      element: <SelectForSecondSession />,
    },
    {
      path: ROUTES.one_to_one_confirm_second_session,
      element: <ConfirmSecondSession />,
    },
    {
      path: ROUTES.one_to_one_confirm_second_session_details,
      element: <SecondSessionDetails />,
    },
    {
      path: ROUTES.materials,
      element: <MaterialsLayout />,
      children: materialsChildren,
    },
    {
      path: ROUTES.exercises,
      element: <ParentRequestLayout />,
      children: exerciseChildren,
    },
  ];

  const menuItems: SidebarItem[] = [
    {
      type: "item",
      name: "Home",
      value: t("menu.home", { defaultValue: "Home" }),
      Icon: HomeIcon,
      path: ROUTES.home,
    },
    {
      type: "item",
      name: "Agenda",
      value: t("menu.agenda", { defaultValue: "Agenda" }),
      Icon: AgendaIcon,
      path: ROUTES.agenda,
    },
    {
      type: "item",
      name: "Exercises",
      value: t("menu.exercises", { defaultValue: "Exercises" }),
      Icon: ExerciseIcon,
      path: ROUTES.exercises,
    },
    {
      type: "item",
      name: "Materials",
      value: t("menu.materials", { defaultValue: "Materials" }),
      Icon: MaterialsIcon,
      path: ROUTES.materials,
    },

    ...(["A0", "A0-"].includes(me?.item.user?.english_level ?? "")
      ? []
      : [
          {
            type: "item",
            name: "1:1 classes",
            value: t("menu.one_to_one", { defaultValue: "1:1 classes" }),
            Icon: OneToOneIcon,
            path: ROUTES.one_to_one,
            isDev: true,
          },
        ]),

    {
      type: "item",
      name: "Diploma request",
      value: t("menu.diploma", { defaultValue: "Diploma request" }),
      Icon: DiplomaRequestIcon,
      path: ROUTES.diploma_request,
    },

    {
      type: "item",
      name: "Class report",
      value: t("menu.class_report", { defaultValue: "Class report" }),
      Icon: FeedbackIcon,
      path: ROUTES.class_report,
    },

    {
      type: "item",
      name: "Invoices & contract",
      value: t("menu.invoices", { defaultValue: "Invoices & contract" }),
      Icon: InvoiceIcon,
      path: ROUTES.invoices,
    },
    ...(me?.item?.hasSpeaking
      ? [
          {
            type: "item",
            name: "Availability",
            value: t("menu.availability", { defaultValue: "Availability" }),
            Icon: AvailabilityIcon,
            path: ROUTES.availability,
          },
        ]
      : []),
    ...(me?.item?.hasIelts && !["es", "de"].includes(me?.item?.user?.lang ?? "")
      ? [
          {
            type: "item",
            name: "Book exam",
            value: t("menu.book_exam", { defaultValue: "Book exam" }),
            Icon: BookExamsIcon,
            path: ROUTES.book_exam,
          },
        ]
      : []),
    {
      type: "regular",
      name: "Refer a friend",
      value: t("menu.refer", { defaultValue: "Refer a friend" }),
      Icon: ReferIcon,
      path: ROUTES.refer_friend,
    },
  ];

  return {
    absolutePathChildren,
    dashboardChildren,
    menuItems,
    absolutePathChildrenV3,
  };
};

export default useRouteObjects;
